import { render, staticRenderFns } from "./InfoPagination.vue?vue&type=template&id=56e0d118&scoped=true"
import script from "./InfoPagination.vue?vue&type=script&lang=js"
export * from "./InfoPagination.vue?vue&type=script&lang=js"
import style0 from "./InfoPagination.vue?vue&type=style&index=0&id=56e0d118&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0d118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e0d118')) {
      api.createRecord('56e0d118', component.options)
    } else {
      api.reload('56e0d118', component.options)
    }
    module.hot.accept("./InfoPagination.vue?vue&type=template&id=56e0d118&scoped=true", function () {
      api.rerender('56e0d118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InfoPagination.vue"
export default component.exports